import { render, staticRenderFns } from "./instory-item-list.vue?vue&type=template&id=1a667a8e&scoped=true&"
import script from "./instory-item-list.vue?vue&type=script&lang=js&"
export * from "./instory-item-list.vue?vue&type=script&lang=js&"
import style0 from "./instory-item-list.vue?vue&type=style&index=0&id=1a667a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a667a8e",
  null
  
)

export default component.exports